<div class="my-cards-widget" [class.my-cards-widget--small]="size === 'small'"
    [class.my-cards-widget--medium]="size === 'medium'" [class.my-cards-widget--half]="size === 'half'"
    [class.my-cards-widget--full]="size === 'full'">

    <!-- Header Section -->
    <div class="my-cards-widget__header-section">
        <div class="my-cards-widget__header">
            <div class="my-cards-widget__header-content">
                <div class="my-cards-widget__title">{{ title }}</div>
                <ng-container *ngIf="isEditMode">
                    <div (click)="toggleSizeDropdown(index, $event)" class="ai-advice-widget__icon-container"
                        cdkOverlayOrigin #editTrigger="cdkOverlayOrigin">
                        <div class="ai-advice-widget__icon">
                            <img src="assets/icons/widget/pencil.svg" alt="Edit">
                        </div>
                    </div>
                    <!-- Size Dropdown -->
                    <app-widget-edit [editTrigger]="editTrigger" [index]="index"
                        [activeDropdownIndex]="activeDropdownIndex" [getAvailableSizes]="getAvailableSizes"
                        [changeWidgetSize]="changeWidgetSize" [removeWidget]="removeWidget"
                        [toggleSizeDropdown]="toggleSizeDropdown">
                    </app-widget-edit>
                </ng-container>
                <ng-container *ngIf="isAddMode">
                    <img class="add-widget-btn-icon no-dark-filter" src="assets/icons/img_frame-1171275385.png"
                        alt="Settings" (click)="addWidget.emit(); $event.stopPropagation()" />
                </ng-container>
            </div>
        </div>

        <!-- Size Dropdown -->
        <!-- <div class="size-dropdown" *ngIf="activeDropdownIndex === index">
            <ng-container *ngFor="let sizeOption of getAvailableSizes(index)">
                <button class="dropdown-item" (click)="changeWidgetSize(index, sizeOption.value)">
                    {{ sizeOption.label }}
                </button>
            </ng-container>
        </div> -->

        <!-- Navigation Controls -->
        <div class="my-cards-widget__controls">
            <button class="my-cards-widget__nav-btn" [disabled]="!canGoPrevious()" (click)="previousCard()">

                <img src="assets/icons/arrow-left.svg" alt="Previous">
            </button>
            <button class="my-cards-widget__manage-btn">
                <span>Manage</span>
            </button>
            <button class="my-cards-widget__nav-btn" [disabled]="!canGoNext()" (click)="nextCard()">

                <img src="assets/icons/arrow-right.svg" alt="Next">
            </button>
        </div>
    </div>

    <!-- Card Slider Section -->
    <div class="my-cards-widget__slider" #sliderContainer>
        <div class="my-cards-widget__slider-track" [style.transform]="getSliderTransform()">
            <div *ngFor="let card of cards; let i = index" class="my-cards-widget__card"
                [style.background]="card.gradient">

                <!-- Card Logo/Brand -->
                <div class="my-cards-widget__card-logo">
                    <img *ngIf="card.logo" [src]="card.logo" alt="Card Brand">
                </div>

                <!-- Card Lock Icon -->
                <div class="my-cards-widget__card-lock">
                    <img src="assets/icons/paypassicon.svg" alt="Lock">
                </div>

                <!-- Card Details -->
                <div class="my-cards-widget__card-details">
                    <div class="my-cards-widget__card-info">
                        <div class="my-cards-widget__card-type">{{ card.type }}</div>
                        <div class="my-cards-widget__card-number">**** {{ card.lastFourDigits }}</div>
                    </div>
                    <div class="my-cards-widget__card-balance-label">Remaining Balance</div>
                </div>

                <!-- Card Balance Amount -->
                <div class="my-cards-widget__card-amount">
                    {{ card.remainingBalance | currency:'INR':'symbol':'1.2-2' }}
                </div>
            </div>
        </div>
    </div>

    <!-- Transactions Section -->
    <div class="my-cards-widget__transactions-section" #transactionsSection>
        <!-- Transactions Header -->
        <div class="my-cards-widget__transactions-header">
            <div class="my-cards-widget__transactions-title">Card Transactions</div>
            <button class="my-cards-widget__see-all-btn" (click)="navigateToTransactions()">See All</button>
        </div>

        <!-- Transaction List -->
        <div class="my-cards-widget__transaction-list" [attr.data-key]="transactionKey">
            <div *ngFor="let transaction of currentCardTransactions" class="my-cards-widget__transaction-item">

                <!-- Transaction Icon -->
                <div class="my-cards-widget__transaction-icon"
                    [style.background-color]="getTransactionBgColor(transaction)">
                    <img src="assets/icons/{{transaction.icon}}">
                </div>

                <!-- Transaction Details -->
                <div class="my-cards-widget__transaction-details">
                    <div class="my-cards-widget__transaction-info">
                        <div class="my-cards-widget__transaction-title">{{ transaction.title }}</div>
                        <div class="my-cards-widget__transaction-date">
                            <span>{{ transaction.date }}</span>
                            <span>{{ transaction.time }}</span>
                        </div>
                    </div>

                    <!-- Transaction Amount -->
                    <div class="my-cards-widget__transaction-amount"
                        [style.color]="transaction.type === 'credit' ? getTransactionColor(transaction) : 'var(--color-primary1)'">
                        {{ formatAmount(transaction.amount) }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>